/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { format, isValid } from "date-fns";
import { Formik, FieldArray } from "formik";
import * as Yup from "yup";
import Grid from "@mui/material/Grid";
import { get } from "lodash";
import { useSelector } from "react-redux";
import { getObjectUsingDatalistValue } from "../../../../../../utils/helper";
import { getUAEBankName } from "../../../../../../store/selectors/appConfig";

import {
  Input,
  SelectAutocomplete,
  AsyncSelectAutoComplete,
  AutoSaveField as Field,
  DatePicker,
  Checkbox,
  InlineRadioGroup
} from "../../../../../../components/Form";

import { ArrayRemoveButton } from "../../../Buttons/ArrayRemoveButton";
import { ArrayAddButton } from "../../../Buttons/ArrayAddButton";
import { ContinueButton } from "../../../../../../components/Buttons/ContinueButton";
import { BASED_IN } from "./constants";
import { Accordian } from "../../../../../../components/Accordian";
import { DATE_FORMAT } from "../../../../../../constants";
import { CoBorrowerAECBConsent } from "./CoBorrowerAECBConsent";

import {
  UAE_IBAN_REGEX,
  ALPHANUMERIC_REGEX,
  DECIMAL_TWO_DIGIT_DECIMAL_REGEX,
  NUMBER_REGEX,
  SPECIAL_CHARACTERS_REGEX
} from "../../../../../../utils/validation";
import { getInvalidMessage } from "../../../../../../utils/getValidationMessage";

import { Title, ButtonWrapper, FormContainer, RemoveButton, AddButton } from "./styled";
import { ScrollToError } from "components/ScrollToError";

export const companyBankDetailsInUAESchema = () =>
  Yup.object().shape({
    doesSisterCompUseSamebankAccount: Yup.string()
      .nullable()
      .max(10, "Maximum 10 characters allowed"),
    sisterCompanyCoBorrower: Yup.string()
      .nullable()
      .max(10, "Maximum 10 characters allowed"),
    dateOfIncorpOtherBranch: Yup.date()
      .nullable()
      .max(new Date(), getInvalidMessage("Date of Incorporation"))
      .typeError(getInvalidMessage("Date of Incorporation")),
    bankDetailsInUAE: Yup.array().of(
      Yup.object().shape({
        bankName: Yup.string()
          .nullable()
          .max(50, "Maximum 50 characters allowed"),
        iban: Yup.string()
          .nullable()
          .matches(UAE_IBAN_REGEX, getInvalidMessage("IBAN")),
        currency: Yup.string()
          .nullable()
          .max(3, "Maximum 3 characters allowed"),
        loanExists: Yup.string().nullable(),
        loanType: Yup.string()
          .nullable()
          .max(50, "Maximum 50 characters allowed")
          .matches(SPECIAL_CHARACTERS_REGEX, getInvalidMessage("Finance/Facility Type")),
        loanAmount: Yup.string()
          .nullable()
          .max(13, "Maximum 13 characters allowed")
          .matches(NUMBER_REGEX, getInvalidMessage("Finance/Facility Amount")),
        loanCurrency: Yup.string()
          .nullable()
          .max(3, "Maximum 3 characters allowed")
      })
    ),
    otherBankLoanExist: Yup.string().nullable(),
    otherBankLoanRelationship: Yup.array().of(
      Yup.object().shape({
        bankName: Yup.string()
          .nullable()
          .max(50, "Maximum 50 characters allowed"),
        iban: Yup.string()
          .nullable()
          .matches(ALPHANUMERIC_REGEX, getInvalidMessage("IBAN"))
          .max(23, "Maximum 23 characters allowed"),
        currency: Yup.string()
          .nullable()
          .max(3, "Maximum 3 characters allowed"),
        loanFacility: Yup.string()
          .nullable()
          .max(50, "Maximum 50 characters allowed"),
        basedIn: Yup.string().nullable(),
        loanAvailedDate: Yup.date()
          .nullable()
          .max(new Date(), getInvalidMessage("Date Loan facility availed"))
          .typeError(getInvalidMessage("Date Loan facility availed")),
        emiPaid: Yup.string()
          .nullable()
          .max(13, "Maximum 13 characters allowed")
          .matches(NUMBER_REGEX, getInvalidMessage("EMI paid/ tenure paid")),
        emiAmount: Yup.string()
          .nullable()
          .max(13, "Maximum 13 characters allowed")
          .matches(DECIMAL_TWO_DIGIT_DECIMAL_REGEX, getInvalidMessage("EMI amount")),
        emiClearing: Yup.date()
          .nullable()
          //.max(new Date(), getInvalidMessage("EMI Clearing"))
          .typeError(getInvalidMessage("EMI Clearing")),
        clearingBank: Yup.string()
          .nullable()
          .max(50, "Maximum 50 characters allowed"),
        takeOverBank: Yup.string()
          .nullable()
          .max(50, "Maximum 50 characters allowed"),
        outstandingExposure: Yup.string()
          .nullable()
          .max(13, "Maximum 13 characters allowed")
          .matches(NUMBER_REGEX, getInvalidMessage("EMI amount")),
        facilityLetterProvided: Yup.string()
          .nullable()
          .max(10, "Maximum 10 characters allowed"),
        howPreviousRBLUtilised: Yup.string()
          .nullable()
          .max(255, "Maximum 255 characters allowed"),
        howOtherBankLoanUtilised: Yup.string()
          .nullable()
          .max(255, "Maximum 255 characters allowed")
      })
    )
  });

export const intialBankDetailsInUAE = {
  bankName: "",
  iban: "",
  currency: "",
  loanExists: "",
  loanType: "",
  loanAmount: "",
  loanCurrency: ""
};
export const intialOtherBankLoanRelationship = {
  bankName: "",
  iban: "",
  currency: "",
  loanFacility: "",
  basedIn: "",
  loanAvailedDate: "",
  emiPaid: "",
  emiAmount: "",
  emiClearing: "",
  clearingBank: "",
  takeOverBank: "",
  outstandingExposure: "",
  facilityLetterProvided: "",
  howPreviousRBLUtilised: "",
  howOtherBankLoanUtilised: ""
};
export const initialValues = (companyName, sisterCompanyDetails, eIndex) => {
  return {
    sisterCompanyName: companyName,
    doesSisterCompUseSamebankAccount: "",
    sisterCompanyCoBorrower: "",
    dateOfIncorpOtherBranch: "",
    bankDetailsInUAE: [intialBankDetailsInUAE],
    otherBankLoanExist: "",
    // otherBankLoanRelationship: [intialOtherBankLoanRelationship]
    otherBankLoanRelationship:
      sisterCompanyDetails[eIndex] && sisterCompanyDetails[eIndex].otherBankLoanRelationship
        ? sisterCompanyDetails[eIndex].otherBankLoanRelationship.length > 1
          ? sisterCompanyDetails[eIndex].otherBankLoanRelationship.map(item => ({
              ...item
            }))
          : [intialOtherBankLoanRelationship]
        : [intialOtherBankLoanRelationship]
  };
};

export const changeDateProspectHandler = (_, value, path) =>
  isValid(value) && { [path]: format(value, DATE_FORMAT) };

export const CompanyBranchesAndSubsidiariesComponent = ({
  handleContinue,
  createFormChangeHandler,
  updateRoProspect,
  orgKYCDetails,
  roDocuments,
  sisterCompanyDetails,
  sendProspectToAPI,
  updateProspect,
  getDatalistSearch
}) => {
  const dataList = useSelector(getUAEBankName);
  const otherEntitiesInUAE = get(orgKYCDetails, "otherEntitiesInUAE", false);
  const { entitiesInUAE = [] } = orgKYCDetails;

  let coBorrowers = [];
  let coBorrowersConsentPending = [];
  const sisterCompanyRef = useRef();
  const [sisCompName, setSisCompName] = useState("");
  entitiesInUAE.forEach((coBorrower, coIndex) => {
    if (sisterCompanyDetails[coIndex]?.sisterCompanyCoBorrower === "Yes") {
      coBorrowers.push({ index: coIndex, data: coBorrower });
    }
  });
  entitiesInUAE.forEach((coBorrower, coIndex) => {
    if (sisterCompanyDetails[coIndex]?.sisterCompanyCoBorrower === "Yes") {
      coBorrowersConsentPending.push({ index: coIndex, data: coBorrower });
    }
  });
  useEffect(() => {
    if (!otherEntitiesInUAE && (sisterCompanyDetails && sisterCompanyDetails.length > 0)) {
      sisterCompanyDetails.forEach((sisterCompany, sisIndex) => {
        updateRoProspect({
          [`roProspect.organizationInfoRO.sisterCompanyDetails[${sisIndex}].doesSisterCompUseSamebankAccount`]: "",
          [`roProspect.organizationInfoRO.sisterCompanyDetails[${sisIndex}].sisterCompanyCoBorrower`]: "",
          [`roProspect.organizationInfoRO.sisterCompanyDetails[${sisIndex}].dateOfIncorpOtherBranch`]: "",
          [`roProspect.organizationInfoRO.sisterCompanyDetails[${sisIndex}].bankDetailsInUAE`]: [
            intialBankDetailsInUAE
          ],
          [`roProspect.organizationInfoRO.sisterCompanyDetails[${sisIndex}].otherBankLoanExist`]: "",
          [`roProspect.organizationInfoRO.sisterCompanyDetails[${sisIndex}].otherBankLoanRelationship`]: [
            intialOtherBankLoanRelationship
          ]
        });
      });
    }
  }, [otherEntitiesInUAE]);
  useEffect(() => {
    if (otherEntitiesInUAE && (sisterCompanyDetails && sisterCompanyDetails.length > 0)) {
      sisterCompanyDetails.forEach((sisterCompany, sisIndex) => {
        updateRoProspect({
          [`roProspect.organizationInfoRO.sisterCompanyDetails[${sisIndex}].doesSisterCompUseSamebankAccount`]: "",
          [`roProspect.organizationInfoRO.sisterCompanyDetails[${sisIndex}].sisterCompanyCoBorrower`]: "",
          [`roProspect.organizationInfoRO.sisterCompanyDetails[${sisIndex}].dateOfIncorpOtherBranch`]: "",
          [`roProspect.organizationInfoRO.sisterCompanyDetails[${sisIndex}].bankDetailsInUAE`]: [
            intialBankDetailsInUAE
          ],
          [`roProspect.organizationInfoRO.sisterCompanyDetails[${sisIndex}].otherBankLoanExist`]: "",
          [`roProspect.organizationInfoRO.sisterCompanyDetails[${sisIndex}].otherBankLoanRelationship`]: [
            intialOtherBankLoanRelationship
          ]
        });
      });
    }
  }, [entitiesInUAE]);

  useEffect(() => {
    if (
      entitiesInUAE.length !== sisterCompanyDetails.length &&
      entitiesInUAE.length < sisterCompanyDetails.length
    ) {
      let arrDif = sisterCompanyDetails.length - entitiesInUAE.length;
      entitiesInUAE.forEach((item, sisIndex) => {
        updateRoProspect({
          [`roProspect.organizationInfoRO.sisterCompanyDetails[${sisIndex}].sisterCompanyName`]: item.companyName
        });
      });
      let removedArray = sisterCompanyDetails;
      const updatedArray = removedArray.slice(0, removedArray.length - arrDif);
      updateRoProspect({
        "roProspect.organizationInfoRO.sisterCompanyDetails": updatedArray
      });
    }
  }, [entitiesInUAE]);

  useEffect(() => {
    if (otherEntitiesInUAE && entitiesInUAE.length > 0) {
      sisterCompanyRef.current.setFieldValue("sisterCompanyName", sisCompName);
      sisterCompanyRef.current.setFieldValue("sisterCompanyCoBorrower", "");
    }
  }, [sisCompName]);

  return (
    <>
      {otherEntitiesInUAE && entitiesInUAE.length > 0 ? (
        <>
          {entitiesInUAE.map((entity, eIndex) => {
            const roProspectPath = `roProspect.organizationInfoRO.sisterCompanyDetails[${eIndex}]`;
            return (
              <Accordian key={eIndex} accordianHeader={entity.companyName}>
                <Formik
                  initialValues={initialValues(entity.companyName, sisterCompanyDetails, eIndex)}
                  validationSchema={companyBankDetailsInUAESchema}
                  onSubmit={handleContinue}
                  validateOnChange={false}
                  innerRef={sisterCompanyRef}
                >
                  {createFormChangeHandler(({ values, setFieldValue, setTouched }) => {
                    const bankDetailsInUAE =
                      values.bankDetailsInUAE &&
                      values.bankDetailsInUAE.length &&
                      values.bankDetailsInUAE.length > 1;
                    const otherBankLoanExist =
                      values.otherBankLoanExist && values.otherBankLoanRelationship.length > 1;

                    setSisCompName(entity.companyName);

                    let uaeBankSelected = {};
                    let uaeBankSelectedArr = [];
                    values.bankDetailsInUAE.forEach((items, index) => {
                      if (dataList) {
                        if (values.bankDetailsInUAE[index].bankName !== "") {
                          uaeBankSelected = getObjectUsingDatalistValue(
                            dataList,
                            values.bankDetailsInUAE[index].bankName
                          );
                          uaeBankSelectedArr.push(uaeBankSelected);
                        }
                      }
                    });
                    let bankSelected = {};
                    let bankSelectedArr = [];
                    values.otherBankLoanRelationship.forEach((items, index) => {
                      if (dataList) {
                        if (values.otherBankLoanRelationship[index].bankName !== "") {
                          bankSelected = getObjectUsingDatalistValue(
                            dataList,
                            values.otherBankLoanRelationship[index].bankName
                          );
                          bankSelectedArr.push(bankSelected);
                        }
                      }
                    });
                    let clearingBank = {};
                    let clearingBankArr = [];
                    values.otherBankLoanRelationship.forEach((items, index) => {
                      if (dataList) {
                        if (values.otherBankLoanRelationship[index].clearingBank !== "") {
                          clearingBank = getObjectUsingDatalistValue(
                            dataList,
                            values.otherBankLoanRelationship[index].clearingBank
                          );
                          clearingBankArr.push(clearingBank);
                        }
                      }
                    });
                    let takeOver = {};
                    let takeOverBankArr = [];
                    values.otherBankLoanRelationship.forEach((items, index) => {
                      if (dataList) {
                        if (values.otherBankLoanRelationship[index].takeOverBank !== "") {
                          takeOver = getObjectUsingDatalistValue(
                            dataList,
                            values.otherBankLoanRelationship[index].takeOverBank
                          );
                          takeOverBankArr.push(takeOver);
                        }
                      }
                    });

                    return (
                      <FormContainer>
                        <ScrollToError />
                        <Grid container spacing={3}>
                          <Grid item sm={6} xs={12}>
                            <p>Does this company use same bank account of the proposed company?</p>
                          </Grid>
                          <Grid item sm={6} xs={12}>
                            <Field
                              path={`${roProspectPath}.doesSisterCompUseSamebankAccount`}
                              name="doesSisterCompUseSamebankAccount"
                              label="Please select"
                              component={SelectAutocomplete}
                              datalistId="flagWithNa"
                              shrink
                              tabIndex="0"
                            />
                          </Grid>

                          <Grid item sm={6} xs={12}>
                            <p>Is this company a co. borrower or guarantor?</p>
                          </Grid>
                          <Grid item sm={6} xs={12}>
                            <Field
                              path={`${roProspectPath}.sisterCompanyCoBorrower`}
                              name="sisterCompanyCoBorrower"
                              label="Please select"
                              component={SelectAutocomplete}
                              datalistId="YesNoList"
                              shrink
                              tabIndex="0"
                            />
                          </Grid>

                          <Grid item sm={6} xs={12}>
                            <p>Date of Incorporation</p>
                          </Grid>
                          <Grid item sm={6} xs={12}>
                            <Field
                              path={`${roProspectPath}.dateOfIncorpOtherBranch`}
                              name="dateOfIncorpOtherBranch"
                              label="Date of Incorporation"
                              component={DatePicker}
                              InputProps={{
                                inputProps: { tabIndex: 0 }
                              }}
                              changeProspect={changeDateProspectHandler}
                              maxDate={new Date()}
                            />
                          </Grid>
                          <Field
                            type="hidden"
                            name="sisterCompanyName"
                            path={`${roProspectPath}.sisterCompanyName`}
                          />

                          <FieldArray name="bankDetailsInUAE">
                            {arrayHelpers => (
                              <Grid item sm={12}>
                                <Grid container spacing={3}>
                                  <>
                                    {values.bankDetailsInUAE.map((item, index) => (
                                      <React.Fragment key={index}>
                                        <Grid item sm={6} xs={12}>
                                          <Field
                                            name={`bankDetailsInUAE[${index}].bankName`}
                                            path={`${roProspectPath}.bankDetailsInUAE[${index}].bankName`}
                                            label="Bank name"
                                            component={AsyncSelectAutoComplete}
                                            getDatalistSearch={getDatalistSearch}
                                            codeType="UAEB"
                                            defaultValue={uaeBankSelectedArr[index]}
                                            InputProps={{
                                              inputProps: { tabIndex: 0 }
                                            }}
                                          />
                                        </Grid>

                                        <Grid item sm={6} xs={12}>
                                          <Field
                                            name={`bankDetailsInUAE[${index}].iban`}
                                            path={`${roProspectPath}.bankDetailsInUAE[${index}].iban`}
                                            label="IBAN"
                                            autoComplete="off"
                                            component={Input}
                                            InputProps={{
                                              inputProps: { tabIndex: 0, maxLength: 23 }
                                            }}
                                          />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                          <Field
                                            name={`bankDetailsInUAE[${index}].currency`}
                                            path={`${roProspectPath}.bankDetailsInUAE[${index}].currency`}
                                            label="Currency"
                                            component={SelectAutocomplete}
                                            datalistId="accountCurrencies"
                                            InputProps={{
                                              inputProps: { tabIndex: 0 }
                                            }}
                                          />
                                        </Grid>
                                        <Grid item sm={12} xs={12}>
                                          <Field
                                            name={`bankDetailsInUAE[${index}].loanExists`}
                                            path={`${roProspectPath}.bankDetailsInUAE[${index}].loanExists`}
                                            label="The company has a loan/finance with this Bank"
                                            component={Checkbox}
                                            InputProps={{
                                              inputProps: { tabIndex: 0 }
                                            }}
                                          />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                          <Field
                                            name={`bankDetailsInUAE[${index}].loanType`}
                                            path={`${roProspectPath}.bankDetailsInUAE[${index}].loanType`}
                                            label="Finance/Facility Type"
                                            placeholder="Finance/Facility Type"
                                            component={Input}
                                            tabIndex="0"
                                          />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                          <Field
                                            name={`bankDetailsInUAE[${index}].loanAmount`}
                                            path={`${roProspectPath}.bankDetailsInUAE[${index}].loanAmount`}
                                            label="Finance/Facility Amount"
                                            component={Input}
                                            InputProps={{
                                              inputProps: { tabIndex: 0 }
                                            }}
                                          />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                          <Field
                                            name={`bankDetailsInUAE[${index}].loanCurrency`}
                                            path={`${roProspectPath}.bankDetailsInUAE[${index}].loanCurrency`}
                                            label="Finance/Facility Currency"
                                            component={SelectAutocomplete}
                                            datalistId="accountCurrencies"
                                            InputProps={{
                                              inputProps: { tabIndex: 0 }
                                            }}
                                          />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                          {bankDetailsInUAE && (
                                            <ArrayRemoveButton
                                              arrayHelpers={arrayHelpers}
                                              dataArray={values.bankDetailsInUAE}
                                              itemIndex={index}
                                              updateProspect={updateRoProspect}
                                              title="Delete"
                                              className={RemoveButton}
                                            />
                                          )}
                                        </Grid>
                                      </React.Fragment>
                                    ))}
                                  </>

                                  <Grid item sm={12} xs={12}>
                                    {" "}
                                    <ArrayAddButton
                                      title="Add Bank"
                                      limit={3}
                                      requiredFields={["bankName", "iban"]}
                                      addedItem={intialBankDetailsInUAE}
                                      dataArray={values.bankDetailsInUAE}
                                      arrayHelpers={arrayHelpers}
                                      className={AddButton}
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                          </FieldArray>

                          <Grid item sm={6} xs={12}>
                            <Field
                              path={`${roProspectPath}.otherBankLoanExist`}
                              name="otherBankLoanExist"
                              InputProps={{
                                inputProps: { tabIndex: 0 }
                              }}
                              label="Borrowing/Finance with any other Banks?"
                              component={Checkbox}
                            />
                          </Grid>

                          {values.otherBankLoanExist && (
                            <FieldArray name="otherBankLoanRelationship">
                              {arrayHelpers => (
                                <Grid item sm={12}>
                                  <Grid container spacing={3}>
                                    <>
                                      {values.otherBankLoanRelationship.map(
                                        (loanRelationship, index) => (
                                          <React.Fragment key={index}>
                                            <Grid item sm={6} xs={12}>
                                              <Field
                                                name={`otherBankLoanRelationship[${index}].bankName`}
                                                path={`${roProspectPath}.otherBankLoanRelationship[${index}].bankName`}
                                                label="Bank name"
                                                component={AsyncSelectAutoComplete}
                                                codeType="UAEB"
                                                defaultValue={bankSelectedArr[index]}
                                                getDatalistSearch={getDatalistSearch}
                                                InputProps={{
                                                  inputProps: { tabIndex: 0 }
                                                }}
                                              />
                                            </Grid>

                                            <Grid item sm={6} xs={12}>
                                              <Field
                                                name={`otherBankLoanRelationship[${index}].iban`}
                                                path={`${roProspectPath}.otherBankLoanRelationship[${index}].iban`}
                                                label="IBAN"
                                                component={Input}
                                                InputProps={{
                                                  inputProps: { tabIndex: 0, maxLength: 23 }
                                                }}
                                              />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                              <Field
                                                name={`otherBankLoanRelationship[${index}].currency`}
                                                path={`${roProspectPath}.otherBankLoanRelationship[${index}].currency`}
                                                label="Currency"
                                                component={SelectAutocomplete}
                                                datalistId="accountCurrencies"
                                                InputProps={{
                                                  inputProps: { tabIndex: 0 }
                                                }}
                                              />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                              <Field
                                                name={`otherBankLoanRelationship[${index}].loanFacility`}
                                                path={`${roProspectPath}.otherBankLoanRelationship[${index}].loanFacility`}
                                                label="Loan facility"
                                                component={Input}
                                                tabIndex="0"
                                              />
                                            </Grid>

                                            <Grid item sm={10} xs={12}>
                                              <Field
                                                name={`otherBankLoanRelationship[${index}].basedIn`}
                                                path={`${roProspectPath}.otherBankLoanRelationship[${index}].basedIn`}
                                                label="Where are they based?"
                                                component={InlineRadioGroup}
                                                options={BASED_IN}
                                                InputProps={{
                                                  inputProps: { tabIndex: 0 }
                                                }}
                                              />
                                            </Grid>
                                            {loanRelationship.basedIn === "Within UAE" && (
                                              <>
                                                <Grid item sm={6} xs={12}>
                                                  <Field
                                                    name={`otherBankLoanRelationship[${index}].loanAvailedDate`}
                                                    path={`${roProspectPath}.otherBankLoanRelationship[${index}].loanAvailedDate`}
                                                    label="Date Loan facility availed"
                                                    component={DatePicker}
                                                    InputProps={{
                                                      inputProps: { tabIndex: 0 }
                                                    }}
                                                    changeProspect={changeDateProspectHandler}
                                                    maxDate={new Date()}
                                                  />
                                                </Grid>
                                                <Grid item sm={6} xs={12}>
                                                  <Field
                                                    name={`otherBankLoanRelationship[${index}].emiPaid`}
                                                    path={`${roProspectPath}.otherBankLoanRelationship[${index}].emiPaid`}
                                                    label="EMI paid/ tenure paid"
                                                    placeholder="EMI paid/ tenure paid"
                                                    component={Input}
                                                    InputProps={{
                                                      inputProps: {
                                                        tabIndex: 0
                                                      }
                                                    }}
                                                  />
                                                </Grid>
                                                <Grid item sm={6} xs={12}>
                                                  <Field
                                                    name={`otherBankLoanRelationship[${index}].emiAmount`}
                                                    path={`${roProspectPath}.otherBankLoanRelationship[${index}].emiAmount`}
                                                    label="EMI amount"
                                                    placeholder="EMI amount"
                                                    component={Input}
                                                    InputProps={{
                                                      inputProps: { tabIndex: 0 }
                                                    }}
                                                  />
                                                </Grid>
                                                <Grid item sm={6} xs={12}>
                                                  <Field
                                                    name={`otherBankLoanRelationship[${index}].emiClearing`}
                                                    path={`${roProspectPath}.otherBankLoanRelationship[${index}].emiClearing`}
                                                    label="EMI Clearing"
                                                    component={DatePicker}
                                                    InputProps={{
                                                      inputProps: { tabIndex: 0 }
                                                    }}
                                                    changeProspect={changeDateProspectHandler}
                                                    disableFuture={false}
                                                  />
                                                </Grid>
                                                <Grid item sm={6} xs={12}>
                                                  <Field
                                                    name={`otherBankLoanRelationship[${index}].clearingBank`}
                                                    path={`${roProspectPath}.otherBankLoanRelationship[${index}].clearingBank`}
                                                    label="Clearing Bank"
                                                    component={AsyncSelectAutoComplete}
                                                    codeType="UAEB"
                                                    getDatalistSearch={getDatalistSearch}
                                                    defaultValue={clearingBankArr[index]}
                                                    InputProps={{
                                                      inputProps: { tabIndex: 0 }
                                                    }}
                                                  />
                                                </Grid>
                                                <Grid item sm={6} xs={12}>
                                                  <Field
                                                    name={`otherBankLoanRelationship[${index}].takeOverBank`}
                                                    path={`${roProspectPath}.otherBankLoanRelationship[${index}].takeOverBank`}
                                                    label="Take Over Bank"
                                                    component={AsyncSelectAutoComplete}
                                                    codeType="UAEB"
                                                    getDatalistSearch={getDatalistSearch}
                                                    defaultValue={takeOverBankArr[index]}
                                                    InputProps={{
                                                      inputProps: { tabIndex: 0 }
                                                    }}
                                                  />
                                                </Grid>
                                                <Grid item sm={6} xs={12}>
                                                  <Field
                                                    name={`otherBankLoanRelationship[${index}].outstandingExposure`}
                                                    path={`${roProspectPath}.otherBankLoanRelationship[${index}].outstandingExposure`}
                                                    label="Outstanding or Clean Exposure"
                                                    placeholder="Outstanding or Clean Exposure"
                                                    component={Input}
                                                    InputProps={{
                                                      inputProps: { tabIndex: 0 }
                                                    }}
                                                  />
                                                </Grid>
                                                <Grid item sm={6} xs={12}>
                                                  <Field
                                                    name={`otherBankLoanRelationship[${index}].facilityLetterProvided`}
                                                    path={`${roProspectPath}.otherBankLoanRelationship[${index}].facilityLetterProvided`}
                                                    label=" Facility Letter for all trade finance and business documents provided"
                                                    component={SelectAutocomplete}
                                                    datalistId="flagWithNa"
                                                    InputProps={{
                                                      inputProps: { tabIndex: 0 }
                                                    }}
                                                  />
                                                </Grid>
                                                <Grid item sm={6} xs={12}>
                                                  <Field
                                                    name={`otherBankLoanRelationship[${index}].howPreviousRBLUtilised`}
                                                    path={`${roProspectPath}.otherBankLoanRelationship[${index}].howPreviousRBLUtilised`}
                                                    label="Comment on how was the previous RBL utilised"
                                                    placeholder="Comment on how was the previous RBL utilised"
                                                    component={Input}
                                                    multiline
                                                    rows={4}
                                                    InputProps={{
                                                      inputProps: { tabIndex: 0 }
                                                    }}
                                                  />
                                                </Grid>
                                                <Grid item sm={6} xs={12}>
                                                  <Field
                                                    name={`otherBankLoanRelationship[${index}].howOtherBankLoanUtilised`}
                                                    path={`${roProspectPath}.otherBankLoanRelationship[${index}].howOtherBankLoanUtilised`}
                                                    label="Comment on how was Other Bank business loans utilised since previous RBL or 12 months( whichever was most recent)"
                                                    placeholder="Comment on how was Other Bank business loans utilised since previous RBL or 12 months( whichever was most recent)"
                                                    component={Input}
                                                    multiline
                                                    rows={4}
                                                    InputProps={{
                                                      inputProps: { tabIndex: 0 }
                                                    }}
                                                  />
                                                </Grid>
                                              </>
                                            )}

                                            <Grid sm={otherBankLoanExist ? 12 : false}>
                                              {otherBankLoanExist && (
                                                <ArrayRemoveButton
                                                  arrayHelpers={arrayHelpers}
                                                  dataArray={values.otherBankLoanRelationship}
                                                  itemIndex={index}
                                                  prospectPath={`${roProspectPath}.otherBankLoanRelationship`}
                                                  updateProspect={updateRoProspect}
                                                  title="Delete"
                                                  className={RemoveButton}
                                                />
                                              )}
                                            </Grid>
                                          </React.Fragment>
                                        )
                                      )}
                                    </>

                                    <Grid item sm={12} xs={12}>
                                      <ArrayAddButton
                                        title="Add Bank"
                                        limit={3}
                                        requiredFields={["bankName", "iban"]}
                                        addedItem={intialOtherBankLoanRelationship}
                                        dataArray={values.otherBankLoanRelationship}
                                        arrayHelpers={arrayHelpers}
                                        className={AddButton}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            </FieldArray>
                          )}
                        </Grid>
                      </FormContainer>
                    );
                  })}
                </Formik>
              </Accordian>
            );
          })}{" "}
          {coBorrowers.length > 0 && (
            <>
              <Title variant="h4">Co Borrower AECB and FTS Physical Consent</Title>
              {coBorrowersConsentPending.length > 0 ? (
                <CoBorrowerAECBConsent
                  roDocuments={roDocuments}
                  coBorrowers={coBorrowersConsentPending}
                  sendProspectToAPI={sendProspectToAPI}
                  handleContinue={handleContinue}
                  updateProspect={updateProspect}
                />
              ) : (
                <h4>Consent already given</h4>
              )}
            </>
          )}
        </>
      ) : (
        <h5>Branches or subsidiaries or other companies in the UAE are not found</h5>
      )}{" "}
      {((coBorrowersConsentPending.length === 0 && otherEntitiesInUAE) || !otherEntitiesInUAE) && (
        <ButtonWrapper>
          <ContinueButton handleClick={handleContinue} />
        </ButtonWrapper>
      )}
      {/* <InfoTitle
        classes={{ wrapper: classes.infoTitles }}
        title="For it to appear here, also add a branch, subsidiary or company under the Branches and subsidiaries section above"
      /> */}
    </>
  );
};

CompanyBranchesAndSubsidiariesComponent.propTypes = {
  /**
   * Function to handle form submission and continue to next step
   */
  handleContinue: PropTypes.func.isRequired,

  /**
   * Function to create form change handler with additional functionality
   */
  createFormChangeHandler: PropTypes.func.isRequired,

  /**
   * Function to update RO prospect data in Redux store
   */
  updateRoProspect: PropTypes.func.isRequired,

  /**
   * Organization KYC details containing information about branches and subsidiaries
   */
  orgKYCDetails: PropTypes.shape({
    otherEntitiesInUAE: PropTypes.bool,
    entitiesInUAE: PropTypes.arrayOf(
      PropTypes.shape({
        companyName: PropTypes.string.isRequired,
        consentDone: PropTypes.bool
      })
    )
  }),

  /**
   * Object containing documents information for the company
   */
  roDocuments: PropTypes.shape({
    companyDocuments: PropTypes.array
  }),

  /**
   * Array of sister company details
   */
  sisterCompanyDetails: PropTypes.arrayOf(
    PropTypes.shape({
      sisterCompanyName: PropTypes.string,
      sisterCompanyCoBorrower: PropTypes.string,
      doesSisterCompUseSamebankAccount: PropTypes.string,
      dateOfIncorpOtherBranch: PropTypes.string,
      bankDetailsInUAE: PropTypes.array,
      otherBankLoanExist: PropTypes.string,
      otherBankLoanRelationship: PropTypes.array
    })
  ),

  /**
   * Function to send prospect data to the API
   */
  sendProspectToAPI: PropTypes.func.isRequired,

  /**
   * Function to update prospect data in Redux store
   */
  updateProspect: PropTypes.func.isRequired,

  /**
   * Function to search datalist by code type
   */
  getDatalistSearch: PropTypes.func.isRequired
};
